<!--
 * @Author: Tahiti
 * @Date: 2025-11-03 10:06:52
 * @LastEditors: Tahiti
 * @LastEditTime: 2026-01-05 17:33:36
 * @Description: 
 * @FilePath: /weryai-web/components/ui/VideoBottomInfo.vue
-->
<script setup lang="ts">
import ToolIntroduce from '~/components/aiToolsBottom/ToolIntroduce.vue'
import ReasonWaterfull from '~/components/aiToolsBottom/ReasonWaterfull.vue'
import QuestionAnswer from '~/components/aiToolsBottom/QuestionAnswer.vue'

const props = defineProps({
    introduce: {
        type: Object,
        default: () => ({
            title: '标题',
            desc: '描述',
            video: '',
            urls: [],
        }),
    },
    selectReason: {
        type: Object,
        default: () => ({
            title: '标题',
            btnInfo: '',
            desc: [],
        }),
    },
    howToUse: {
        type: Object,
        default: () => ({
            title: 'HOW TO USE',
            desc: '',
            steps: [],
            img: '',
        }),
    },
    exploreOthers: {
        type: Object,
        default: () => ({
            title: '更多工具',
            showTypes: [],
        }),
    },
    questionAnswer: {
        type: Object,
        default: () => ({
            title: '常见问题',
            qAData: [],
        }),
    },
    // 新增：模型介绍区块配置（用于视频特效工具）
    modelIntro: {
        type: Object,
        default: () => null,
    },
    customCategory: {
        type: String,
        default: '',
    },
    btnInfo: {
        type: String,
        default: '',
    },
    title1: {
        type: String,
        default: '',
    },
    title2: {
        type: String,
        default: '',
    },
    keyFeatureTitle: {
        type: String,
        default: '',
    },
    keyFeatureDesc: {
        type: String,
        default: '',
    },
    img_class: {
        type: String,
        default: '',
    },
})
</script>

<template>
    <div class="aiToolsBottom">
        <ToolIntroduce :title1="title1" :title2="title2" v-bind="introduce"></ToolIntroduce>
        <ReasonWaterfull v-bind="selectReason" :customCategory="customCategory" :btnInfo="btnInfo"
            :keyFeatureTitle="keyFeatureTitle" :keyFeatureDesc="keyFeatureDesc" :img_class="img_class">
        </ReasonWaterfull>

        <QuestionAnswer v-bind="questionAnswer"></QuestionAnswer>

        <AppFooter />
    </div>
</template>

<style lang="less" scoped>
.aiToolsBottom {
    width: calc(100% - 122px);
    margin: 0 auto;
    text-align: center;
    margin-left: 106px;
    position: relative;
    z-index: 1;

    @media (max-width: 768px) {
        width: 100%;
        margin-left: 0;
        padding: 0 16px;
    }
}
</style>
